<template>
  <div>
    <div class="action">
      <el-checkbox v-model="hideZero">隐藏余额为0的币种</el-checkbox>
    </div>
    <el-table :data="userWallet | filterList(hideZero)">
      <el-table-column prop="coinType" label="币种">
      </el-table-column>
      <el-table-column prop="c2cBuy" label="C2C买入">
      </el-table-column>
      <el-table-column prop="c2cSell" label="C2C卖出">
      </el-table-column>
      <el-table-column prop="deposit" label="充值">
      </el-table-column>
      <el-table-column prop="withdrawal" label="提现">
      </el-table-column>
      <el-table-column prop="coinAmount" label="wallet可用">
      </el-table-column>
      <el-table-column prop="coinFroze" label="wallet冻结">
      </el-table-column>
      <el-table-column prop="otcCoinFroze" label="otc冻结"></el-table-column>
      <el-table-column prop="otcCoinAmount" label="otc总量"></el-table-column>
      <el-table-column prop="totalAmount" label="总量"></el-table-column>

    </el-table>
  </div>
  
</template>

<script>
import { mapState } from 'vuex';

export default {
  data() {
    return {
      hideZero: false
    };
  },
  computed: {
    ...mapState('withdrawalAudit', ['userWallet'])
  },
  filters: {
    filterList: (value, isHide) => {
      return value.filter(item => (isHide ? item.totalAmount !== 0 : true));
    }
  }
};
</script>

<style scoped lang="less">
.action {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-bottom: 20px;
}
</style>
